import React, { useContext } from 'react';
import { Html, Bvh, meshBounds } from '@react-three/drei';


const Button = ({ position, text, onClick, size, visible= false }) => {
    if (!visible) return null;

    return (
        <Bvh
            firstHitOnly
            raycast={meshBounds}
            onPointerEnter={() => { document.body.style.cursor = 'pointer'}}
            onPointerLeave={() => { document.body.style.cursor = 'default' }}
        >
            <Html
                position={position}
                center
                distanceFactor={size}
                className={`btn ${visible ? 'display' : 'hidden'}`}
            >
                <div className="text-container" onClick={onClick}>
                    {text}
                </div>
            </Html>
        </Bvh>
    );
};

export default Button;
